import { ModulesMap, ModulesConfigMap } from "../data/modulesMaps";

export default {
  getReportsFinanceByWorkCategories: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_WORK_CATEGORIES].GET_REPORTS_FINANCE_BY_WORK_CATEGORIES
  }
}